module.exports = __webpack_public_path__ + "static/rutterkin-8d5252e9ac412f7419e706f71c369529.png";